module.exports = __webpack_public_path__ + "img/arrow-down-language-white.4dacb2a4.svg";